// CSV in and out, for the pages that let people edit in Excel and hand it back.
//
// The parser is a real one rather than a split on commas: a product called
// "PICKLE, MANGO" or an address with a line break inside quotes is ordinary in
// this data and would otherwise shift every column after it.

export function parseCSV(text) {
  const rows = []; let row = []; let field = ''; let i = 0; let q = false;
  while (i < text.length) {
    const c = text[i];
    if (q) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i += 2; continue; }   // "" is one quote
        q = false; i++; continue;
      }
      field += c; i++; continue;
    }
    if (c === '"') { q = true; i++; continue; }
    if (c === ',') { row.push(field); field = ''; i++; continue; }
    if (c === '\r') { i++; continue; }
    if (c === '\n') { row.push(field); rows.push(row); row = []; field = ''; i++; continue; }
    field += c; i++;
  }
  if (field.length || row.length) { row.push(field); rows.push(row); }
  return rows;
}

export const csvCell = (v) => {
  const s = v == null ? '' : String(v);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// Headers are matched loosely — "On hand", "on_hand" and "ONHAND" are the same
// column to anyone typing it, so they are the same column here.
export const normHeader = (h) => String(h || '').toLowerCase().replace(/[^a-z0-9]/g, '');

// Rows of objects → a file the browser saves. The BOM is what makes Excel open
// UTF-8 correctly; without it, Indian names come out as mojibake.
const tableLines = (headers, rows) => [
  headers.map(([label]) => csvCell(label)).join(','),
  ...rows.map((r) => headers.map(([, key]) => csvCell(typeof key === 'function' ? key(r) : r[key])).join(',')),
];

export const downloadCSV = (filename, headers, rows) => saveLines(filename, tableLines(headers, rows));

// Several titled tables in one file, separated by a blank line — one download
// instead of two, which browsers would otherwise prompt about.
export const downloadCSVSections = (filename, sections) => {
  const lines = [];
  sections.forEach(({ title, headers, rows }, i) => {
    if (i) lines.push('');
    if (title) lines.push(csvCell(title));
    lines.push(...tableLines(headers, rows));
  });
  saveLines(filename, lines);
};

const saveLines = (filename, lines) => {
  const blob = new Blob(['﻿' + lines.join('\r\n') + '\r\n'], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

// A parsed file → objects keyed by our own field names, carrying the line each
// came from so an error can point at it.
export const rowsFromCSV = (text, headerMap) => {
  const grid = parseCSV(String(text)).filter((r) => r.some((c) => String(c).trim() !== ''));
  if (!grid.length) return { rows: [], headers: [] };
  const headers = grid[0].map((h) => headerMap[normHeader(h)] || null);
  const rows = grid.slice(1).map((cells, i) => {
    const o = { line: i + 2 };
    headers.forEach((key, idx) => { if (key) o[key] = String(cells[idx] ?? '').trim(); });
    return o;
  });
  return { rows, headers };
};
